import { ComplaintSchema } from 'mk2/containers/Complaint/Complaint.schemas';
import {
    COMPLAINTS_DELETE,
    ComplaintsDeleteAction,
    complaintsDeleteAPI,
} from 'mk2/containers/Complaints/Complaints.actions';
import { deleteComplaints } from 'mk2/containers/Complaints/Complaints.api';
import { getComplaintsComplaints } from 'mk2/containers/Complaints/Complaints.selectors';
import { handleXHRPostErrorSaga, XHRAction, XHRPostError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import * as React from 'react';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

const logger = getLogger('Complaint.sagas');

export function* complaintsDelete({ entity, id, xhr }: ComplaintsDeleteAction & XHRAction) {
    // Clear local data
    let complaints = yield select(getComplaintsComplaints, entity, id);
    complaints = complaints.map((complaint) => {
        return {
            ...complaint,
            deletedAt: (new Date()).toISOString(),
        };
    });

    yield put(complaintsDeleteAPI.request(entity, id));

    try {
        const response = yield call(deleteComplaints, xhr, entity, id);
        const normalizedResponse = normalize(complaints, [ComplaintSchema]);

        // TODO: How to remove entities?
        yield put(complaintsDeleteAPI.success(entity, id, normalizedResponse));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(complaintsDeleteAPI.failure(entity, id, error));
    }
}

export default function* root() {
    yield all([
        takeEvery(COMPLAINTS_DELETE, complaintsDelete),
    ]);
}
